import { render, staticRenderFns } from "./OrderCalendar.vue?vue&type=template&id=22cc5994&scoped=true&"
import script from "./OrderCalendar.vue?vue&type=script&lang=js&"
export * from "./OrderCalendar.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendar.vue?vue&type=style&index=0&id=22cc5994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc5994",
  null
  
)

export default component.exports